import { TutorialDefinition } from '../../../types/tutorial';

const scrollToElement = async (selector: string) => {
  const element = document.querySelector(selector);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Wait for scroll animation to complete
    await new Promise((resolve) => setTimeout(resolve, 400));
  }
};

export const transcriptToolsTutorial: TutorialDefinition = {
  id: 'transcript-tools',
  initialAnimation: 'top-right',
  steps: [
    {
      id: 'tools-intro',
      title: 'Transcript tools sidebar',
      content:
        "<p>This sidebar contains all the tools you need to work with your transcript. Let me show you what's available.</p>",
      placement: 'center',
    },
    {
      id: 'transcript-meta',
      targetSelector: '[data-tutorial="transcript-meta"]',
      title: 'Transcript information',
      content:
        '<p>Here you can see transcript details like duration, word count, and creation date. You can also add notes and view AI-generated summary.</p>',
      placement: 'left',
      offsetX: -10,
      action: () => scrollToElement('[data-tutorial="transcript-meta"]'),
    },
    {
      id: 'speakers-section',
      targetSelector: '[data-tutorial="speakers-section"]',
      title: 'Manage speakers',
      content:
        '<p>View and manage all speakers in your transcript. You can rename speakers, merge them, or add new ones.</p>',
      placement: 'left',
      offsetX: -10,
      action: () => scrollToElement('[data-tutorial="speakers-section"]'),
    },
    {
      id: 'edit-history-section',
      targetSelector: '[data-tutorial="edit-history-section"]',
      title: 'Edit history',
      content:
        '<p>View all changes made to your transcript and navigate between different versions. You can undo or redo changes from here.</p>',
      placement: 'left',
      offsetX: -10,
      action: () => scrollToElement('[data-tutorial="edit-history-section"]'),
    },
    {
      id: 'export-section',
      targetSelector: '[data-tutorial="export-section"]',
      title: 'Export options',
      content: '<p>Export your transcript in PDF or DOCX formats.</p>',
      placement: 'left',
      offsetX: -10,
      action: () => scrollToElement('[data-tutorial="export-section"]'),
    },
  ],
};
